import axios from 'axios';
import api_url from '../urls';

const actions = {

    AddFuncionario (context, value) {
        console.log(value)

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.post(api_url.api_admin + 'v1/admin/funcionarios',
        {
          nome: value.nome.trim(),
          sobrenome: value.sobrenome.trim(),
          perfil_id: value.perfil_id,
          polo_id: '1',
          empresa_id:1,
          status: '1',
          doc_oficial: value.doc_oficial.trim(),
          telefone: value.telefone.trim(),
          celular:value.celular.trim(),
          email:value.email.trim(),
          data_nascimento:value.data_nascimento,
          profissao_id: value.profissao.id,
          escolaridade_id: value.escolaridade.id,
          tipo_documento_id: value.tipo_documento.id,
          sexo_id: value.sexo.id,
          estado_civil_id: value.estado_civil.id,
          endereco: value.endereco.trim(),
          numero:value.numero.trim(),
          cidade_id:value.cidade.id,
          naturalidade_id: value.naturalidade.id,

        }
        , {
            headers: {
                'authorization': AuthStr,
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
             console.log(response);
          //  context.commit('ADD_FUNCIONARIO', value )
        })
        .catch((error) => {
            alert(error.response.data.message)
            console.log(error.response);
        });
        
    },

    allFuncionarios (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/allfuncionarios',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
          //   console.log(response);
            context.commit('ALL_FUNCIONARIOS', response.data)
        })
        .catch((error) => {
            alert(error.response.data.message + 'Clique en salir depues revuelve a logar!')
          //  if (error.response.data.message = 'Unauthenticated.') {
               // this.$router.push({ name: 'auth/login' }) 
           // } 
          //  console.log(error.response);
        });
        
    },
    allProfessores (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/allprofessores',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             console.log(response);
            context.commit('ALL_PROFESSORES', response.data)
        })
        .catch((error) => {
            console.log(error);
        });
        
    },
    setFuncionarioaa(context,value){

     context.commit('SET_FUNCIONARIO', value)
       
        
    }
   
}

export default actions